import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, NavLink, Route, Switch, useHistory, withRouter} from 'react-router-dom';
import {PropTypes} from "prop-types";
import {bindActionCreators} from "redux";

import ScholarContent from "../../../components/scholar/front/detail/content";
import ScholarSide from "../../../components/scholar/front/detail/side";
import Loading from "../../../components/etc/loading";

import * as Actions from "../../../store/modules/scholars";
import * as func from "../../../utils/functions";
import * as hooks from "../../../utils/hooks";

import {BASE_PATH} from "../../../wpconfig";

class Scholar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isInit: false,
			action : 'scholar'
		}
	}

	componentDidMount() {
		hooks.menuHook(this, this.state.action);
		this.getDetail();
	}

	componentWillUnmount(){
		this.setState = (state, callback) => {
			return;
		}
	}

	getDetail() {
		func.getData(this.state.action + "/" + func.getParams("record_id"), null).then((response) => {
			this.setState({
				isInit: true,
			})
			this.props.dataActions.setScholar(response);

			func.getData("code/search/scholar_id_type", {}).then((response) => {
				const t = {}
				response.records.map((r, i) => {
					t[r.code_id] = r
				});
				this.props.dataActions.setScholar({'code' : t});
			});

			func.getData("scholar_stats/" + func.getParams("record_id"), null).then((response) => {
				if (response.record) {
					response.stats = response.record;
					delete response.record;
				}
				this.props.dataActions.setScholar(response);
			});
		});
	}

	render() {
		// const record = this.props.record;
		// console.log(record);
		// console.log(this)
		return (
			<>
				{!this.state.isInit ? <Loading/> :
					<div className="contents-group">
						<ScholarContent/>
						<div id="LineChartToolTip" className="line-chart-tooltip"/>
					</div>
				}
			</>
		)
	}
}

export default connect(
	(state) => ({
		// record : state.scholars.record ? state.scholars.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(Scholar)

Scholar.propTypes = {
	record: PropTypes.object,
	// records : PropTypes.array,
	// facet : PropTypes.object,
	// totalRecords : PropTypes.number,
	// totalPage : PropTypes.number,
};
